export const setCountMap = (mapObj, id, name) => {
  const stage = mapObj.get(id);

  if (stage) {
    mapObj.set(id, { ...stage, count: stage.count + 1 });
  } else {
    mapObj.set(id, { name, id, count: 1 });
  }
};
